import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import { Button } from "@libs/rubick";
import { XMarkIcon } from "@heroicons/react/24/outline";
export function EditNodeModal({ isOpen, onClose, onSubmit, initialDescription, initialLocation, isSubmitting, error }) {
    const [description, setDescription] = useState(initialDescription);
    const [location, setLocation] = useState(initialLocation);
    useEffect(()=>{
        if (isOpen) {
            setDescription(initialDescription);
            setLocation(initialLocation);
        }
    }, [
        isOpen,
        initialDescription,
        initialLocation
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        await onSubmit({
            description,
            location
        });
    };
    return /*#__PURE__*/ _jsx(Transition, {
        appear: true,
        show: isOpen,
        children: /*#__PURE__*/ _jsxs(Dialog, {
            className: "relative z-50",
            onClose: onClose,
            children: [
                /*#__PURE__*/ _jsx(TransitionChild, {
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "fixed inset-0 bg-black bg-opacity-50"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ _jsx(TransitionChild, {
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ _jsxs(DialogPanel, {
                                className: "w-full max-w-md transform overflow-visible rounded-xl bg-white p-6 text-left align-middle shadow-xl transition-all",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-between mb-6",
                                        children: [
                                            /*#__PURE__*/ _jsx(DialogTitle, {
                                                as: "h3",
                                                className: "text-xl font-semibold text-gray-900",
                                                children: "Edit Node"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: onClose,
                                                className: "p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100",
                                                disabled: isSubmitting,
                                                children: /*#__PURE__*/ _jsx(XMarkIcon, {
                                                    className: "h-5 w-5"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("form", {
                                        onSubmit: handleSubmit,
                                        className: "space-y-4",
                                        children: [
                                            error && /*#__PURE__*/ _jsx("div", {
                                                className: "p-3 bg-red-50 border border-red-200 rounded-lg",
                                                children: /*#__PURE__*/ _jsx("p", {
                                                    className: "text-red-600 text-sm",
                                                    children: error
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("label", {
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Description"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        value: description,
                                                        onChange: (e)=>setDescription(e.target.value),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors",
                                                        maxLength: 255,
                                                        disabled: isSubmitting,
                                                        placeholder: "Enter description"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("label", {
                                                        className: "block text-sm font-medium text-gray-700 mb-1",
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        value: location,
                                                        onChange: (e)=>setLocation(e.target.value),
                                                        className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors",
                                                        maxLength: 255,
                                                        disabled: isSubmitting,
                                                        placeholder: "Enter location"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex justify-end space-x-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        variant: "simple",
                                                        color: "red",
                                                        onClick: onClose,
                                                        disabled: isSubmitting,
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        variant: "simple",
                                                        color: "navy-90",
                                                        disabled: isSubmitting,
                                                        children: isSubmitting ? "Saving..." : "Save"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
